import { memo } from 'react';
import Icon from '../Icon';
import Typography from '../Typography';

import './PointsBoostBadge.scss';

const PointsBoostBadgeComponent = () => {
  return (
    <div className="nostra__pointsBoostBadge">
      <Icon variant="boost-arrow" size={12} />
      <Typography variant="button-xs" weight="semi-bold" color="text-primary-darkbg">
        Points boost
      </Typography>
    </div>
  );
};
export const PointsBoostBadge = memo(PointsBoostBadgeComponent);
